<template>
  <div class="lotus_content">
    <section class="box_vqmm flex-grow-1 text-center">
      <div class="_game_name">
        <template>
          <img src="@/assets/images/Game_name_vn.png" />
        </template>
      </div>
      <div class="bg_wheel">
        <div>
          <img src="@/assets/images/wheel@2x.png" class="__www" />
          <div class="__vqmm">
            <div
              v-if="!isAuthenticate || !currentUser.turns || inValidCampaign()"
              @click.prevent="handleInvalidWheel"
            >
              <img src="@/assets/images/wheel-play.png" />
              <a
                href="javascript:;"
                slot="button"
                :class="currentLocale === 'en' ? 'btn-quay-en' : 'btn-quay'"
                class="btn-vqmm-cursor"
              />
            </div>
            <FortuneWheel
              style="width: 394px"
              type="image"
              :useWeight="true"
              :prizes="gifts"
              :prizeId="prizeId"
              :duration="8000"
              :disabled="isDrawing"
              :angleBase="12"
              @rotateStart="onImageRotateStart"
              @rotateEnd="onRotateEnd"
              v-else
            >
              <img
                slot="wheel"
                style="transform: rotate(30deg);max-width: 100%;max-height: 100%;"
                src="@/assets/images/wheel-play.png"
              />
              <a
                href="javascript:;"
                slot="button"
                :class="currentLocale === 'en' ? 'btn-quay-en' : 'btn-quay'"
                class="btn-vqmm-cursor"
              />
            </FortuneWheel>
          </div>
        </div>
      </div>
      <div class="bg_machine_body">
        <img src="@/assets/images/cloud 4.png" alt="" class="bg_machine" />
        <img src="@/assets/images/control_board.svg" class="control-board" />
        <span>
          {{ $t("home.current_quantity") }}:
          <label>{{ currentUser.turns || 0 }}</label>
        </span>
      </div>
    </section>
    <!--FOOTER-->

    <footer class="d-flex flex-wrap px-content-1">
      <p class="flex-grow-1">
        Hotline: <a href="tel:1900299232">1900 299 232</a>
      </p>
      <p>
        <a href="#" class="d-flex align-items-center">
          <img src="@/assets/images/ub_logo.svg"  alt=""/>
          <span>Powered by UrBox</span>
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import FortuneWheel from "vue-fortune-wheel";
import { DRAW_GAME, GET_GAME, SHOWING } from "@/stores/actions";
import { mapGetters } from "vuex";
import { GAME_APP } from "@/enums/modules/game";
import JwtService from "@/jwt-service";

export default {
  name: "MainGame",
  components: {
    FortuneWheel,
  },
  created() {
    let vm = this;
    vm.getGame();
  },
  computed: {
    ...mapGetters([
      "currentCustomer",
      "currentUser",
      "gifts",
      "game",
      "isShowing",
      "isAuthenticate",
    ]),
    currentLocale() {
      let vm = this;
      return vm.$route.params.locale;
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      value: "",
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
      prizeId: 0,
      isDrawing: false,
      isSuccess: false,
    };
  },
  mounted() {
    let vm = this;
    let modalOutOfQuantity = $("#modal-out-of-quantity");
    let modalError = $("#modal-error");
    let modalEndCampaign = $("#modal-end-campaign");
    modalOutOfQuantity.on("hidden.bs.modal", function () {
      vm.$router.go(vm.$router.currentRoute);
    });
    modalError.on("hidden.bs.modal", function () {
      vm.$router.go(vm.$router.currentRoute);
    });
    modalEndCampaign.on("hidden.bs.modal", function () {
      if (vm.$router.history.current.name !== "History") {
        vm.$router.go(vm.$router.currentRoute);
      }
    });
  },
  methods: {
    inValidCampaign() {
      let vm = this;
      let startAt = vm.game.start_at;
      let endAt = vm.game.end_at;
      let now = Math.round(new Date().getTime() / 1000);
      return startAt > now || endAt < now;
    },

    getGame(isRetry = 0) {
      let vm = this;
      vm.$store
        .dispatch(GET_GAME)
        .then((res) => {
          // eslint-disable-next-line no-unused-vars,no-undef
          let modalError = $("#modal-error"),
            modalEndOfCampaign = $("#modal-end-campaign");
          if (res && res.status !== 200) {
            if (isRetry === 0) {
              vm.getGame(1);
            } else {
              if (!vm.isShowing) {
                modalError.modal("show");
              }
            }
          } else {
            if (vm.inValidCampaign()) {
              if (!vm.isShowing) {
                modalEndOfCampaign.modal("show");
              }
            } else {
              if (vm.currentRouteName === "luckyDraw" && !vm.isAuthenticate) {
                // eslint-disable-next-line no-undef
                $("#modal-welcome").modal("show");
              }
            }
            vm.showing();
          }
        })
        .catch(() => {
          if (isRetry === 0) {
            vm.getGame(1);
          }
        });
    },

    showing() {
      let vm = this;
      vm.$store.dispatch(SHOWING);
    },

    handleInvalidWheel() {
      let modalEndOfCampaign = $("#modal-end-campaign");
      let vm = this;
      let startAt = vm.game.start_at;
      let endAt = vm.game.end_at;
      let now = Math.round(new Date().getTime() / 1000);
      if ((startAt > now || endAt < now) && vm.isAuthenticate) {
        modalEndOfCampaign.modal("show");
        return;
      }
      if (!this.currentUser.turns && vm.isAuthenticate) {
        $("#modal-out-of-quantity").modal("show");
        return;
      }
      $("#modal-welcome").modal("show");
    },
    onImageRotateStart() {
      let vm = this;
      vm.isDrawing = true;
      vm.$store
        .dispatch(DRAW_GAME, {
          customer_id: JwtService.getCustomerPhone(),
          game_id: parseInt(GAME_APP.ID),
          app_id: parseInt(GAME_APP.APP_ID),
        })
        .then((res) => {
          if (res && res.status !== 200) {
            vm.showError(res);
          } else {
            vm.prizeId = parseInt(res.data.reward.id);
            vm.isSuccess = true;
          }
        })
        .catch((res) => {
          vm.showError(res);
        });
    },

    onRotateEnd() {
      let vm = this;
      if (vm.isSuccess) {
        // eslint-disable-next-line no-undef
        $("#modal-draw-success").modal("show");
        vm.prizeId = 0;
        vm.isDrawing = false;
        vm.$root.$emit("draw_success", true);
        vm.isSuccess = false;
      }
    },
    showError(res) {
      let vm = this;
      vm.isDrawing = false;
      // eslint-disable-next-line
      let modalOutOfQuantity = $("#modal-out-of-quantity"),
        // eslint-disable-next-line
        modalError = $("#modal-error"),
        // eslint-disable-next-line
        modalEndOfCampaign = $("#modal-end-campaign"),
        // eslint-disable-next-line no-undef
        wheel = $(".fw-wheel");
      wheel.css({ transform: "", "transition-duration": "" });
      let errorCode = res.data?.code;
      if(!errorCode){
        const errors = res.response.data;
        errorCode = errors.code;
      }
      console.log(errorCode);
      if (errorCode === "out_of_game_turns") {
        modalOutOfQuantity.modal("show");
      } else if (errorCode === "game_ended") {
        modalEndOfCampaign.modal("show");
      } else {
        modalError.modal("show");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
@import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
@import "vue-fortune-wheel/lib/vue-fortune-wheel.css";
</style>
